// src/App.js
import React from "react";
import KnightsTour from "../src/components/KnightsTour";

function App() {
  return (
    <div className="App">
      <KnightsTour />
    </div>
  );
}

export default App;



//https://en.wikipedia.org/wiki/Knight%27s_tour

//https://www.javatpoint.com/knight-tour-problem#:~:text=The%20most%20famous%20algorithm%20used,least%20number%20of%20available%20moves.

//https://www.geeksforgeeks.org/the-knights-tour-problem/